import { useState } from 'react';
import { SubmitLoreModal } from './components/SubmitLoreModal/SubmitLoreModal';
import { HeroSection } from './sections/HeroSection';
import { SocialLinksSection } from './sections/SocialLinksSection';
import { ScrollsAndStoriesSection } from './sections/ScrollsAndStoriesSection';
import { SacredCalendarSection } from './sections/SacredCalendarSection';
import { OraclesInboxSection } from './sections/OraclesInboxSection';
import { EVENTS } from 'shared/data/events';
import { ALLOW_SUBMIT_LORE, ALLOW_SUBSCRIPTIONS } from 'shared/constants/common';

export default function Community() {
  const [loreModalOpen, setLoreModalOpen] = useState(false);

  const hasEvents = EVENTS.length > 0 

  return (
    <div className="pb-16 md:pb-32">
      <HeroSection hasEvents={hasEvents} />
      <SocialLinksSection />
      {ALLOW_SUBMIT_LORE ? 
        <ScrollsAndStoriesSection
          onOpenSubmitLore={() => setLoreModalOpen(true)}
        /> : null
      }
      {hasEvents ? <SacredCalendarSection events={EVENTS} /> : null}
      {ALLOW_SUBSCRIPTIONS ? <OraclesInboxSection /> : null}
      <SubmitLoreModal
        isOpen={loreModalOpen}
        onClose={() => setLoreModalOpen(false)}
      />
    </div>
  );
}
